import(/* webpackMode: "eager", webpackExports: ["HomePageTemplate"] */ "/home/jenkins/workspace/prod/deploy-frontend/src/templates/HomePageTemplate/HomePageTemplate.tsx");
